<script lang="ts">
  import { onMount } from 'svelte';
  let inputs: any[] = [];
  export let value;

  const allowedCharacters = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  const onInput = (event, index) => {
    if (
      !['deleteContentBackward', 'insertFromPaste'].includes(event.inputType)
    ) {
      if (!allowedCharacters.includes(event.data)) {
        inputs[index].value = '';
        return;
      }
      if (index < 3) {
        onFocus(index + 1);
      }
    }

    updateValue();
  };

  const onkeyDown = (event, index) => {
    if (event.key === 'Backspace') {
      if (!inputs[index].value && index > 0) {
        inputs[index - 1].value = '';
        onFocus(index - 1);
      }
    }
    if (event.key === 'ArrowRight' && index < 3) {
      event.preventDefault();
      onFocus(index + 1);
    }
    if (event.key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      onFocus(index - 1);
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      onFocus(3);
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      onFocus(0);
    }

    updateValue();
  };

  const onPaste = (event, index) => {
    event.preventDefault();

    const values = event.clipboardData
      .getData('text/plain')
      .replace(/\D/g, '')
      .split('');
    const availableSlots = 4 - index;
    const usedValues = values.splice(0, availableSlots);

    for (let i = 0; i < usedValues.length; i++) {
      inputs[index + i].value = usedValues[i];
    }

    if (index + usedValues.length > 3) {
      inputs[3].focus();
    } else {
      onFocus(index + usedValues.length);
    }

    updateValue();
  };

  const onFocus = index => {
    if (inputs[index].value) {
      inputs[index].setSelectionRange(0, 1);
    }
    inputs[index].focus();
  };

  const updateValue = () => {
    value = inputs.map(input => input.value).join('');
  };

  onMount(() => {
    setTimeout(() => {
      onFocus(0);
    }, 50);
  });
</script>

<div class="code-input">
  {#each Array.from({ length: 4 }) as input, index}
    <input
      bind:this={inputs[index]}
      on:input={e => onInput(e, index)}
      on:keydown={e => onkeyDown(e, index)}
      on:paste={e => onPaste(e, index)}
      on:click|stopPropagation={e => onFocus(index)}
      on:focus|stopPropagation={e => null}
      class="code-input__field"
      maxlength="1"
      pattern="\d*"
      inputmode="numeric"
    />
  {/each}
</div>

<style lang="scss">
  .code-input {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 16px;
    &__field {
      width: 48px;
      font-size: 18px;
      line-height: 22px;
      font-weight: 600;
      color: $color-prussian-blue;
      text-align: center;
      padding: 15px 10px;
      border: 1px solid var(--twism-theme-slightBorder);
      background-color: var(--twism-theme-slightBackground);
      border-radius: 8px;
      transition: all 0.2s ease-in-out;

      &::placeholder {
        color: $color-grat-botticelli;
      }
      &:focus {
        border-color: var(--twism-theme-primary);
        background-color: rgba(0, 0, 0, 0);
      }
    }
  }
</style>
